import { useNavigate } from 'react-router-dom';
import { Material } from '../../../../sp-types/materialType';
import { Product } from '../../../../sp-types/productType';
import React from 'react';
import { getUnitObj } from '../../../../utils/MassUnits/massUnitsUtils';
import { useCurrencyRates } from '@hooks/useCurrencyRates';

interface IProductCardMap {
  filteredProductList: Product[];
  selectedProductId: string;
  setSelectedProductId: React.Dispatch<React.SetStateAction<string>>;
  materialsMap: Record<string, Material>;
  materialColorDictionary: Record<string, string>;
}

export const ProductCardMap: React.FC<IProductCardMap> = ({
  filteredProductList,
  materialColorDictionary,
  materialsMap,
  selectedProductId,
  setSelectedProductId,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col flex-1 overflow-auto gap-2 ">
      {filteredProductList.map(({ name, id, ingredients, measureType, subCategory, category, uuid }, index) => (
        <div
          key={index}
          style={{
            border: selectedProductId === uuid ? '2px solid #e31851' : '2px solid #EAEAEB',
            borderLeft: selectedProductId === uuid ? '10px solid #e31851' : '2px solid #EAEAEB',
            cursor: 'pointer',
          }}
          className={`bg-white shadow-custom py-2  grid grid-cols-13  gap-4 pe-2 min-h-14 ${
            selectedProductId === uuid ? 'ps-2' : 'ps-3'
          } `}
          onClick={() => setSelectedProductId(uuid || selectedProductId)}
          onDoubleClick={() => navigate(`/products-dashboard/${uuid}`)}
        >
          <div className="col-span-1 truncate  content-center " title={id}>
            {id}
          </div>
          <div className="col-span-2 truncate  content-center " title={name}>
            {name}
          </div>
          <div className="col-span-1 truncate  content-center" title={measureType}>
            {measureType}
          </div>
          <div className="col-span-2  content-center" title={category + ' / ' + subCategory}>
            {category + ' / ' + subCategory}
          </div>
          <div className="col-span-2">
            <MaterialDataDiv
              colorDictionary={materialColorDictionary}
              materialId={ingredients[0].materialID}
              materialsMap={materialsMap}
              weightInProduct={ingredients[0].weightInProduct}
            />
          </div>
          {ingredients.slice(1, 3).map((ingredient, index) => (
            <div className="col-span-2" key={index}>
              {ingredient ? (
                <MaterialDataDiv
                  colorDictionary={materialColorDictionary}
                  materialId={ingredient.materialID}
                  materialsMap={materialsMap}
                  weightInProduct={ingredient.weightInProduct}
                />
              ) : (
                <div> </div>
              )}
            </div>
          ))}

          <div className="col-span-1 flex justify-end">
            {ingredients.length > 3 && (
              <div
                className="my-auto w-8 h-8 text-center content-center"
                style={{
                  border: '1px solid #6571FF', // Border styling
                  borderRadius: '9999px', // Equivalent of 'rounded-full'
                }}
              >
                +{ingredients.length - 3}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

interface IMaterialDataDivProps {
  materialId: string;
  materialsMap: Record<string, Material>;
  colorDictionary: Record<string, string>;
  weightInProduct: number;
}

const MaterialDataDiv: React.FC<IMaterialDataDivProps> = ({
  colorDictionary,
  materialId,
  materialsMap,
  weightInProduct,
}) => {
  const material = materialsMap[materialId];
  const { pricesMap } = useCurrencyRates();

  const { name, currentPrice } = material;
  const color = colorDictionary[materialId];

  const text = `${name}  ($${pricesMap[materialId].toFixed(0)}) - ${weightInProduct.toFixed(2)} ${
    getUnitObj(material?.unit).shortForm
  }`;

  return material ? (
    <div
      style={{
        borderLeft: `6px solid ${color} `,
      }}
      className="ps-2 py-2 truncate"
      title={text}
    >
      {text}
    </div>
  ) : (
    <div></div>
  );
};
